

<template>
  <Spinner style="margin-top: 120px;" v-if="!StoreCableStructureCodeRef && !LoadRefGerree" />

  <van-form class="form_longueur" @submit="onSubmit" v-if="StoreCableStructureCodeRef && LoadRefGerree">

    <van-row class=" row-btn-choice ">

      <van-col class="m-r4" v-for="(find, index) in longueurs" v-bind:key="index">
        <van-field v-on:input="inputChange(index)" :disabled="longueurs.length != index + 1"
          class="all_border_radius multiple_longueur" v-if="index == 0" v-model="find.value" :key="index" name="Longueur"
          type="number" step="1" :label="$t('Longueur N°1')" :placeholder="$t('Longueur (m)')" ref="inputFocus"
          :rules="[{ required: true, message: $t('La longueur est requise'), validator, message: $t('Longueur incorrecte') }]" />
        <!--
      <van-field 
      
      v-on:input="inputChange(index)"
      :disabled="(disabledInput && !refGerreeIDentique && !refGerreExist) || longueurs.length != index + 1"
      class="all_border_radius multiple_longueur"
      v-if="index == 0"
      v-model="find.value" 
      :key="index"
        name="Longueur"
        type="number"
        :label="$t('Longueur N°1')"
        :placeholder="$t('Longueur (m)')"
        ref="inputFocus"
        :rules="[{ required: true,  message: $t('La longueur est requise')  , validator, message: $t('Longueur incorrecte')   }]"
      />
     
      <van-field 
        @keyup.+="addFind"
      v-on:input="inputChange(index)"
      :disabled="disabledInput && !refGerreeIDentique && !refGerreExist || longueurs.length != index + 1"
      class="all_border_radius multiple_longueur"
      v-if="index != 0"
      v-model="find.value" 
      :key="index"
        name="Longueur"
        type="number"
        ref="inputFocus"
        :label="$t('Longueur N°') + numberAdd(index) "
        :placeholder="$t('Longueur (m)')"
        :rules="[{ validator, message: $t('Longueur incorrecte') }]"
      />
 -->
        <van-field v-on:input="inputChange(index)" :disabled="longueurs.length != index + 1"
          class="all_border_radius multiple_longueur" v-if="index != 0" v-model="find.value" :key="index" name="Longueur"
          type="number" step="1" ref="inputFocus" :label="$t('Longueur N°') + numberAdd(index)"
          :placeholder="$t('Longueur (m)')" :rules="[{ validator, message: $t('Longueur incorrecte') }]" />

      </van-col>


      <van-col span="2" :style="'display:inline-flex'">

        <van-button :disabled="!longueurs[longueurs.length - 1].value > 0 || disabledPlus" @click="addFind" icon="plus"
          class="all_border_radius btn_add_longueur" type="primary">

        </van-button>

        <!--
  <van-button 
  :disabled=" ( disabledValue(longueurs[longueurs.length - 1 ].value , refGerreeIDentique  ) 
  || longueurs[longueurs.length - 1 ].value >= StoreLongueurMax  || disabledInput )  &&  !refGerreExist 
   " 
  @click="addFind" icon="plus" class="all_border_radius btn_add_longueur" type="primary">

</van-button>
-->
      </van-col>

    </van-row>

    <!--- Reference gérée-->


    <br />

    <div v-if="refGerrees.length > 0 && !refGerreeIDentique && !refGerreExist">


      <h3 v-if="showTitreRefGerree">{{ $t('Longueur standard') }}</h3>

      <van-row>
        <div v-for="(item) in refGerrees" :key="item.id">

          <van-col span="6" class="align-center"
            v-if="item.longueur >= longueurs[longueurs.length - 1].value && item.longueur < longueurs[longueurs.length - 1].value * 1.1 && !refGerreeIDentique">
            <span class="all_border_radius show_ref_gerreer">
              {{ initLongueur(item.longueur) }}
              <b> {{ item.longueur }}m</b>
              <div class="stepper_number_ref_geree">


                <van-button size="small" icon="success" @click="AddRefGerree(item)" type="success">{{ $t('Ajouter') }}
                </van-button>

              </div>

            </span>


          </van-col>

        </div>
        <!--
 <van-button  v-if="showTitreRefGerree" class="btn_refuse_ref_gerree" size="small" icon="cross" @click="DeleteRefGerree()" type="danger">{{ $t('Refuser') }}</van-button>
-->
      </van-row>




    </div>


    <van-notice-bar class="all_border_radius m-t2" v-if="showMessageLongueurMax || disabledPlus" color="#1989fa"
      background="#ecf9ff" left-icon="info-o">
      {{ $t('longueur non standard') }}
    </van-notice-bar>

    <div class="btn_longueur_panier">
      <van-button class="all_border_radius" :disabled="!longueurs[0].value > 0 || disabledPlus" type="success"
        native-type="Valider">
        {{ $t('Ajouter à ma liste') }}
      </van-button>
    </div>


  </van-form>
</template>
    
<script>

import Spinner from '../../../loader/Spinner.vue'
import { showNotify } from 'vant';
export default {
  emits: {
    closePopUpLongueur: null,
    'maj-pannier-ref-gerree': null,
    'count-ref-gerree': null,
  },
  components: {
    Spinner,
  },
  data() {
    return {
      disabledPlus: false,
      showMessageLongueurMax: false,
      showTitreRefGerree: false,
      longueurs: [{ value: null, gerree: false }],
      referenceGereeSelect: null,
      disabledInput: false,
      testcheck: false,
      //ref gerree
      LoadRefGerree: false,
      refGerrees: [],
      valueModel: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      refPanier: [],
      refGerreeIDentique: false,
      refGerreExist: false

    }
  },
  methods: {
    inputChange(i) {

      //Evite les points dans le champ number ...
      const regex = /^[0-9]*$/;
      if (!regex.test(this.longueurs[this.longueurs.length - 1].value)) {
        this.longueurs[this.longueurs.length - 1].value = this.longueurs[this.longueurs.length - 1].value.replace(/[^0-9]/g, "", '');
        return;
      }
      /*
                console.log(this.longueurs[this.longueurs.length - 1].value)
                if (this.longueurs[this.longueurs.length - 1].value.includes('.')) {
                  alert('erreur');
          // afficher un message d'erreur ou empêcher la saisie de la valeur
          return;
        }
        */
      this.showMessageLongueurMax = false
      this.showTitreRefGerree = false
      this.longueurs[i].gerree = false
      this.longueurs[i].item = []
      this.refGerreExist = false
      this.disabledPlus = false
      this.refGerreeIDentique = false
      //Si longueur existe deja

      if (this.longueurs[this.longueurs.length - 1].value >= this.StoreLongueurMax) {
        this.disabledPlus = true
      }

      const longueurInput = this.longueurs[this.longueurs.length - 1].value
      const foundLongueur = this.$store.state.storePrePanier.StoreRefGerree.find(el => el.longueur == longueurInput);
      const foundReference = this.$store.state.storePrePanier.StoreRefGerree.find(el => el.reference == this.checkReferenceGerree);

      var refGerreNoProxy = JSON.parse(JSON.stringify(this.refGerrees))
      for (var j = 0; j < refGerreNoProxy.length; j++) {
        if (refGerreNoProxy[j].longueur == parseInt(longueurInput)) {
          this.refGerreExist = true

          break;

        }
      }
      if (!foundLongueur) {
        this.refGerreeIDentique = false
      } else {
        if (!foundLongueur) {
          this.refGerreeIDentique = false
        } else {
          if (!foundReference) {
            this.refGerreeIDentique = false
          } else {
            this.refGerreeIDentique = true

          }


        }


      }


      setTimeout(() => this.$refs.inputFocus[i].focus(), 300)

    },
    validator(val) {
      if (val >= this.StoreLongueurMax) {
        this.showMessageLongueurMax = true
        this.showTitreRefGerree = false
        this.disabledPlus = true
        return false
      }
      else if (val < 1 && val != '') {
        this.showMessageLongueurMax = false
        return false
      }

      else {
        this.showMessageLongueurMax = false
        return true
      }
    },
    resetLongueur() {
      this.longueurs = [{ value: null, gerree: false }]
    },
    AddRefGerree(item) {

      //Ajoute de la reference gerree
      this.$store.commit('ADD_REF_GERREE', { reference: this.checkReferenceGerree, longueur: item.longueur })


      this.longueurs[this.longueurs.length - 1].value = item.longueur
      this.longueurs[this.longueurs.length - 1].item = item
      this.longueurs[this.longueurs.length - 1].gerree = true

      this.disabledInput = false
      this.showTitreRefGerree = false
      this.refGerreeIDentique = false
      this.longueurs.push({ value: '', gerree: false });

    },
    DeleteRefGerree() {
      this.disabledInput = false
      this.showTitreRefGerree = false
      // this.longueurs.push({ value: '' , gerree: false});

    },
    initLongueur() {
      this.disabledInput = true
      this.showTitreRefGerree = true
    },
    disabledValue(data, refGerreeIDentique) {

      if (data > 0) {

        if (refGerreeIDentique) {

          this.disabledInput = false
          this.showTitreRefGerree = false
          return false
        }
        else {
          if (this.disabledInput == true) {

            return false

          }
          else {
            return false
          }
        }



      } else {
        return false
      }

    },
    majPannierRefGerree(data) {
      this.referenceGereeSelect = data
    },
    numberAdd(number) {
      return number + 1
    },
    addFind: function () {

      this.longueurs.push({ value: '', gerree: false });
      this.disabledInput = false
      this.refGerreExist = false
      this.showTitreRefGerree = false

      var lenghtInput = this.longueurs.length - 1
      setTimeout(() => this.$refs.inputFocus[lenghtInput].focus(), 300)



    },

    ajoutInput() {

    },
    onSubmit() {

      this.lastLongueur = 0;
      //Si valeur non null

      for (let i in this.longueurs) {

        const foundLongueur = this.refGerrees.find(el => el.longueur == parseInt(this.longueurs[i].value));
        // const foundLongueurGerree = this.$store.state.storePrePanier.StoreRefGerree.find(el => el.longueur == this.longueurs[i].value );

        if (this.longueurs[i].value != '') {
          /**
           * Ajout d'un ref gerrée si longueur exacte
           */
          if (foundLongueur) {
            this.longueurs[i].item = foundLongueur
            this.lastLongueur = this.longueurs[i].value
            this.globalFunction.AjoutLignePrePanierRefGerree(this, this.longueurs[i].item);
          }
          /**
           * Ajout d'un ref prk si pas de longueur exacte
           */
          else {
            this.lastLongueur = this.longueurs[i].value
            this.globalFunction.AjoutLignePrePanier(this, this.longueurs[i].value);
          }

        }


      }



      this.obj = {
        'longueur': {
          longueur: this.lastLongueur
        }
      };

      this.$store.commit('REMOVE_CHOICE_LONGUEUR')
      this.$store.commit('SET_CHOICE_LONGUEUR', this.obj)

      //Delete data
      this.longueurs = [{ value: null, gerree: false }]
      this.disabledInput = false
      this.refGerreExist = false
      this.showTitreRefGerree = false
      //this.globalFunction.AjoutLignePrePanier(this);

      this.$emit('closePopUpLongueur', false)


      showNotify({
        message: this.$t('Ajouter à ma liste'),
        type: 'success',
        duration: 2000,
        position: 'bottom',
      });




    },

    /**
     * Reference gerree
     */
    async getRefGerree() {

      fetch(this.$store.state.storeGlobal.StoreApi + '/api/price/refgeree', {
        method: "POST",
        headers: {
      "Accept": "application/json",
      "Content-Type": "application/json; charset=utf-8",
      "Authorization": this.$store.state.storeGlobal.StoreJwtToken
    },
        body: JSON.stringify({
          reference: this.checkReferenceGerree,
          pays: this.$store.state.storeGlobal.StorePays
        })
      }
      ).then(response => {

        return response.json()


      }).then(data => {
        this.refGerrees = data;
        this.LoadRefGerree = true;
      }).catch(function () {
        this.answer = 'Error! Could not reach the API. '
      });

    },
  },
  watch: {
    // à chaque fois que la question change, cette fonction s'exécutera
    StoreCableStructureCodeRef: function (data) {
      if (data == true) {
        setTimeout(() => this.$refs.inputFocus[0].focus(), 600);
        this.getRefGerree()
      }
    },
  },
  mounted() {

  },
  created() {
    this.getRefGerree()

  },
  computed: {
    /** Longueur max cable */
    StoreLongueurMax() {
      return this.globalFunction.existKeyInArray("structure", this.$store.state.storeCable.cable)
        ? this.$store.state.storeCable.cable.structure.longMax
        : null
    },
    checkReferenceGerree() {
      //Snas PRK sans longueur
      var refCommercial = this.globalFunction.createPrkRef(this, 0).substring(4).slice(0, -3);
      //alert(refCommercial)
      return refCommercial
    },
    StoreCableStructureCodeRef() {

      if (this.globalFunction.existKeyInArray("structure", this.$store.state.storeCable.cable) && this.globalFunction.existKeyInArray("diametre", this.$store.state.storeCoB.coB)) {
        /////Structure OK
        if (this.globalFunction.existKeyInArray("codeRefStructure", this.$store.state.storeCable.cable.structure)) {

          return true
        }
        else {

          //Delete data

          this.globalFunction.getCodeRefStructure(this.$store);
          return false
        }
      }
      else {
        return false
      }
    },

  },

}

</script>